import React from 'react';
import { ArrowRight, Phone } from 'lucide-react';
import { heroData } from '../mock/data';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contato');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const whatsappNumber = "5535988192707";
  const whatsappMessage = "Olá! Gostaria de solicitar um orçamento.";
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-[#033530] via-[#044a44] to-[#033530] pt-20">

      {/* Background Pattern - Logo Grid */}
      <div className="absolute inset-0 opacity-[0.10]">
        <div
          className="w-full h-full"
          style={{
            backgroundImage: 'url(/assets/logo-bg.svg)',
            backgroundSize: '60px 60px',
            backgroundRepeat: 'repeat',
            backgroundPosition: 'center'
          }} />

      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-block mb-6">
            <span className="bg-[#ddc183]/10 text-[#ddc183] px-4 py-2 rounded-full text-sm font-medium border border-[#ddc183]/30">
              Registro CREA • Projetos NBR/ABNT
            </span>
          </div>

          {/* Main Heading */}
          <h1 className="md:text-6xl lg:text-7xl !font-bold !text-5xl mb-6 text-[#e8d6b2]">
            {heroData.title}
          </h1>

          {/* Subtitle */}
          <p className="md:text-xl max-w-2xl !text-xl mb-10 mx-auto text-[#e8d6b2]/90">
            {heroData.subtitle}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={scrollToContact}
              className="group bg-[#ddc183] text-[#033530] px-8 py-4 rounded-lg hover:bg-[#c9af71] transition-all duration-300 font-bold text-base flex items-center gap-2 shadow-lg hover:shadow-xl hover:scale-105">

              {heroData.ctaText}
              <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform duration-300" />
            </button>
            
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-transparent border-2 border-[#ddc183] text-[#ddc183] px-8 py-4 rounded-lg hover:bg-[#ddc183] hover:text-[#033530] transition-all duration-300 font-bold text-base flex items-center gap-2 hover:scale-105">

              <Phone size={20} />
              WhatsApp
            </a>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-20 max-w-3xl mx-auto">
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-[#ddc183] mb-2">15+</div>
              <div className="text-sm text-[#e8d6b2]/80">Anos de Experiência</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-[#ddc183] mb-2">500+</div>
              <div className="text-sm text-[#e8d6b2]/80">Projetos Realizados</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-[#ddc183] mb-2">100%</div>
              <div className="text-sm text-[#e8d6b2]/80">Conformidade NBR</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-[#ddc183] mb-2">98%</div>
              <div className="text-sm text-[#e8d6b2]/80">Clientes Satisfeitos</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-[#ddc183]/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-[#ddc183]/50 rounded-full animate-pulse" />
        </div>
      </div>
    </section>);

};

export default Hero;